import { css, keyframes } from '@emotion/css'

import { colors } from '@offerzen/pinata'

const spin = keyframes({
  '0%': {
    transform: 'rotate(0deg)',
  },
  '100%': {
    transform: 'rotate(360deg)',
  },
})

const styles = {
  spinner: css({
    border: `3px solid ${colors.cornflowerBlue}`,
    borderRadius: '50%',
    borderTop: `3px solid ${colors.porcelain}`,
    width: 18,
    minWidth: 18,
    height: 18,
    animation: `${spin} 1s linear infinite`,
  }),
}

export default styles
